import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getPersonalTokenPrecheck, issuePersonalToken } from './tokensApi'

const precheckQueryKey = (email: string) => ['admin', 'personal-tokens', 'precheck', email]

export const usePersonalTokenPrecheckQuery = (email: string) => {
  return useQuery(precheckQueryKey(email), {
    queryFn: () => getPersonalTokenPrecheck(email),
    enabled: email !== '',
    refetchOnWindowFocus: false,
  })
}

export const useIssuePersonalTokenMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (email: string) => issuePersonalToken(email),
    onSuccess: (_result, email) => {
      queryClient.invalidateQueries(precheckQueryKey(email))
    },
  })
}
